import {
  createContext, FC, useCallback, useContext, useEffect, useMemo, useState,
} from 'react';

import { IS_GEEK_MODE } from 'shared/constants/chrome.storage.constants';
import { getValueFromExtChromeStorage, setValueToExtChromeStorage } from 'shared/helpers/storage.helpers';

export type GeekModesState = boolean

type UseGeekModes = { isGeekMode: boolean, toggleGeekMode: () => void }

const initialContextState = { isGeekMode: false, toggleGeekMode: () => null };

export const ExtensionGeekModeContext = createContext<UseGeekModes>(initialContextState);

export const useExtensionGeekMode = (): UseGeekModes => useContext(ExtensionGeekModeContext);

interface Props {
  children: JSX.Element | JSX.Element[];
}

const ExtensionGeekModesProvider: FC<Props> = ({ children }) => {
  const [isGeekMode, setIsGeekMode] = useState<boolean>(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        const isGeek = await getValueFromExtChromeStorage<boolean>(IS_GEEK_MODE);
        setIsGeekMode(Boolean(isGeek) ?? false);
      } catch (error) {
        //
      }
    };

    loadData();
  }, []);

  const toggleGeekMode = useCallback(() => {
    const newMode = !isGeekMode;
    setIsGeekMode(newMode);
    setValueToExtChromeStorage(IS_GEEK_MODE, newMode ? '1' : null);
  }, [isGeekMode]);

  const value = useMemo(() => ({ toggleGeekMode, isGeekMode }), [toggleGeekMode, isGeekMode]);

  return (
    <ExtensionGeekModeContext.Provider value={value}>
      {children}
    </ExtensionGeekModeContext.Provider>
  );
};

export default ExtensionGeekModesProvider;
